import {DeliveryAssignmentStatus} from "../../../components/selector/AssignmentMultiSelect";
import {DeliveryStatus, DeliveryStatusLabels} from "../../../types/delivery/delivery-status";

export const convertAssignmentStatusListToDeliveryStatus = (statusList: DeliveryAssignmentStatus[]): string | undefined => {
    if (statusList.length <= 0) return undefined

    const deliveryStatuses: string[] = [];

    if (statusList.includes(DeliveryAssignmentStatus.BeforeMatched)) {
        deliveryStatuses.push(DeliveryStatus.Wait);
    }

    if (statusList.includes(DeliveryAssignmentStatus.AfterMatched)) {
        deliveryStatuses.push(
            DeliveryStatus.Matched,
            DeliveryStatus.Start,
            DeliveryStatus.PickUp,
            DeliveryStatus.Ship,
            DeliveryStatus.DropOff
        );
    }

    return Array.from(new Set(deliveryStatuses)).join(';');
};

export const convertStatusesToEnumString = (statuses: string[]): string | undefined => {
    const enumStatuses = statuses
        .map((status) => status as DeliveryStatus | undefined)
        .filter((status): status is DeliveryStatus => status !== undefined);

    return enumStatuses.length > 0 ? enumStatuses.join(";") : undefined;
};
